<template>
  <div class="nodeBox" :class="{ 'selectedBox': selected }">
    <Handle
      type="target"
      position="top"
      :style="{
        height: '10px',
        width: '10px',
        backgroundColor: 'white',
        border: 'thin solid #dadada',
      }"
    />
    <NodeHeader :title="data.label" :hook="''" />
    <div
      style="
        width: 100%;
        height: 1px;
        margin: 10px 0;
        background-color: #dadada;
      "
    ></div>
    <div class="flexLeftRow">
      <div class="turningAnimation">
        <svg width="20" height="20" viewBox="0 0 97 97" fill="none">
          <path
            d="M7 48.5C7 25.5802 25.5802 7 48.5 7"
            stroke="#808080"
            stroke-width="10"
            stroke-linecap="round"
          />
        </svg>
      </div>
      <p style="margin-left: 15px">Searching for tools...</p>
    </div>
    <Handle
      type="source"
      position="bottom"
      :style="{
        height: '10px',
        width: '10px',
        backgroundColor: 'white',
        border: 'thin solid #dadada',
      }"
    />
  </div>
</template>

<script>
import { Handle } from "@vue-flow/core";
import NodeHeader from "./NodeComponents/NodeHeader.vue";
import { ScanBarcode, ListPlus } from "lucide-vue-next";

export default {
  name: "LoadingNode",
  props: {
    selected: Boolean,
    data: Object,
    id: String,
    // title: String,
    // text: String,
  },
  components: {
    NodeHeader,
    Handle,
  },
  methods: {
    toggleOptions() {
      this.toggledOptions = !this.toggledOptions;
    },
    async suggestTool() {
      console.log("clicked on select");
      console.log(this.data);
      console.log(this.id);

      this.$emit("updateNodeTool", this.id, this.data);
    },
  },
  data() {
    return {
      toggledOptions: false,
      ScanBarcode,
      ListPlus,
      // PenTool,
    };
  },
};
</script>

<style scoped>
.nodeBox {
  border: thin solid #dadada;
  border-radius: 7px;
  padding: 10px;
  background: white;
  max-width: 230px;
  min-width: 230px;
}
.nodeBox:hover {
  border: thin solid #721cff;
}
.nodeBox:active {
  box-shadow: 0 0 0 3px #ccadff;
}
.selectedBox {
  border: thin solid #721cff;
  box-shadow: 0 0 0 3px #ccadff;
}
.imgBox {
  height: 35px;
  width: 35px;
  background: #721cff10;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
}
#toolbar {
  position: absolute;
  background: #00000080;
  /* border: thin solid #721cff; */
  /* box-shadow: 0 0 0 3px #00000080; */
  transform: translate(-13px, -63px);
  padding: 6px;
  border-radius: 10px;
  display: flex;
}
</style>
